import * as Yup from 'yup';
import { v4 as uuidV4 } from 'uuid';
import { IOptionType } from '@zz2/zz2-ui';
import { IRegion } from '../region/region';
import { ICountry } from './country';
import { ICountryFormValues } from './countryFormValues';
import { ICountryUpsert } from './countryUpsert';

export default class CountryModelHelper {
    public static createFormValues = (
        country : ICountry | null,
        regions : Array<IRegion>
    ) : ICountryFormValues => {
        if (!country) return {
            id: 0,
            guid: uuidV4(),
            code: '',
            name: '',
            region: null,
            isActive: true,
        };

        const region = regions.find(x => x.id === country.regionId);

        return {
            id: country.id,
            guid: country.guid,
            code: country.code,
            name: country.name,
            region: region
                ?  { // TODO: OptionType.FromDataModel
                    value: region.id,
                    label: `(${region.code}) - ${region.name}`,
                }
                : null,
            isActive: country.isActive,
        };
    };

    public static createUpsert = (formValues : ICountryFormValues) : ICountryUpsert => {
        return {
            id: formValues.id,
            guid: formValues.guid,
            code: formValues.code,
            name: formValues.name,
            regionId: formValues.region ? Number(formValues.region.value) : null,
            isActive: formValues.isActive,
        };
    };

    public static formSchema = () : Yup.ObjectSchema<ICountryFormValues> => Yup.object().shape({
        id: Yup.number().typeError('Please enter a number.').required('Required'),
        guid: Yup.string().required('Required'),
        code: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        name: Yup.string().trim().min(1, 'Must have at least 1 character').required('Required'),
        region: Yup.mixed<IOptionType>().defined().nullable(),
        isActive: Yup.boolean().required('Required'),
    });
}
